import { render, staticRenderFns } from "./CommunityFamilyAssignment.vue?vue&type=template&id=ecb050be&scoped=true&"
import script from "./CommunityFamilyAssignment.vue?vue&type=script&lang=js&"
export * from "./CommunityFamilyAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecb050be",
  null
  
)

export default component.exports